/*
  MVK: keep the product title on one whole word per line, at any window size.
  Starts at the theme's normal heading size and shrinks only as far as needed so the
  longest word fits its column. It never splits a word.
*/
(function () {
  var MIN_PX = 14;

  function fit(title) {
    title.style.fontSize = '';
    var size = parseFloat(getComputedStyle(title).fontSize);
    var guard = 60;
    while (title.scrollWidth > title.clientWidth + 1 && size > MIN_PX && guard-- > 0) {
      size -= 1;
      title.style.fontSize = size + 'px';
    }
  }

  function fitAll() {
    document.querySelectorAll('.product__title > h1').forEach(fit);
  }

  function start() {
    fitAll();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(fitAll);
      document.querySelectorAll('.product__info-container').forEach(function (el) {
        ro.observe(el);
      });
    } else {
      window.addEventListener('resize', fitAll);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
